export const periods = [
  { value: 'monthly', title: 'Monthly Billing' },
  { value: 'yearly', title: 'Yearly Billing' }
]

export const plan_types = {
  advisor: [
    { 
      value: 'essentials', 
      title: 'Essentials Plan', 
      popular: false,
      features: {
        title: 'Ideal for advisors who prefer to create and manage their own marketing, with access to intuitive tools and a curated library of content crafted for a luxury audience',
        items: [
          'Email & social designer + scheduler',
          'Branded newsletter template',
          'Full content library access',
          'Canva integration plus 100+ social templates',
          'Lead magnet, landing pages, opt-in forms',
          'CRM, analytics and automation',
          'Website hosting (design sold separately)',
          'Standard Support (human + helpdesk)'
        ]
      }
    },
    { 
      value: 'pro', 
      title: 'Pro Plan', 
      popular: true,
      features: {
        title: 'Ideal for advisors who want done-for-you marketing that\'s branded, pre-scheduled, and designed to save time—with the flexibility to make it their own',
        items: [
          'Everything in Essentials',
          'Up to 2 Done-for-you email newsletters / mo',
          'Up to 30 Done-for-you social posts / mo',
          'Campaigns pre-scheduled for you',
          'Email preview before content goes live',
          'Edit, skip, or create your own content',
          'Custom intro submission + design',
          'Pro Support (text swaps + image edits)'
        ]
      }
    },
    { 
      value: 'website', 
      title: 'Website Only', 
      popular: false,
      features: {
        title: 'Ideal for advisors who manage their own marketing—or need a custom website—with access to intuitive tools and a curated content library for a luxury audience',
        items: [
          'Website hosting (design sold separately)',
          'Email & social designer + scheduler',
          'Branded newsletter template',
          'Full content library access',
          'Canva integration plus 100+ social templates',
          'Lead magnet, landing pages, opt-in forms',
          'CRM, analytics and automation',
          'Standard Support (human + helpdesk)'
        ]
      }
    }
  ],
  agency: [
    { 
      value: 'pro', 
      title: 'Pro Plan', 
      popular: true,
      features: {
        title: 'Your all-in-one platform to manage and scale marketing across your advisor network. Automated, centralized, and fully customizable.',
        items: [
          'Automated Content Distribution at Scale',
          'Agency-Wide Analytics & Reporting',
          'Custom Agency Content Library',
          'Flexible Campaign Creation & Editing Tools',
          'Agency Support (Unlimited Access + Team Onboarding & Training)',
          'Advanced Tools & Features'
        ]
      }
    }
  ]
}